module.exports = __webpack_public_path__ + "img/7.000c83da.jpg";